// removed by extract-text-webpack-plugin
module.exports = {"presenter-name":"style__presenter-name___3VtyU"};


//////////////////
// WEBPACK FOOTER
// ./components/PresenterName/style.scss
// module id = 1305
// module chunks = 0